/* dl-search.js — one search takeover for header, homepage hero and "/"
   Backed by Shopify Predictive Search (/search/suggest.json).

   2026-08-27 — ZNAČKA DOSTALA VLASTNÍ PRUH + BÍLÝ VZHLED.
   Předtím: nalezená kolekce se vykreslila jako obyčejný řádek v levém sloupci
   mezi našeptávanými dotazy, popsaný šedivě „kolekce". Data byla správně —
   API na „Artemide" vrací kolekci i produkty — ale nešlo poznat, že jde
   o značku. Teď se první nalezená kolekce povýší na samostatný pruh přes celou
   šířku pod vyhledávacím polem: logo (z metafieldu custom.logo, dodává
   dl-search-config), název, počet produktů a šipka do kolekce.
   Vizuál: mřížka výsledků byla šedé pole (background #E5E3DE prosvítající
   1px mezerami). Teď je bílá s vlasovými linkami na kartách, karty se sázejí
   přes auto-fill, takže vyplní šířku, a levý sloupec se úplně skryje, když
   nejsou žádné našeptávané dotazy (typicky u značek) — produkty pak zaberou
   celou plochu místo aby zbyla prázdná půlka.
   Rollback = assets/dl-search-backup-20260827.txt */
(function(){
const $=(s,e=document)=>e.querySelector(s), $$=(s,e=document)=>[...e.querySelectorAll(s)];
const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const cfg=window.DL_SEARCH||{};
/* 2026-08-03 fix: routes.predictive_search_url renders as /search/suggest (no .json) —
   fetching that returns HTTP 422 and the takeover silently never updated. */
let ROOT=(cfg.routes&&cfg.routes.predictive)||"/search/suggest";
if(!/\.json$/.test(ROOT)) ROOT+=".json";
const SEARCH_URL=(cfg.routes&&cfg.routes.search)||"/search";
const CATALOG=cfg.catalogCount||"";
/* handle -> {title,url,count,logo}; plní dl-search-config z menu „znacky“ */
const BRANDS={}; (cfg.brands||[]).forEach(b=>{ if(b&&b.handle) BRANDS[b.handle]=b; });
const handleOf=u=>{ const m=String(u||"").match(/\/collections\/([^/?#]+)/); return m?m[1]:""; };
/* price style everywhere (Hynek 2026-10-12): 25 000 Kč — whole crowns, space-grouped, like the store money format
   {{amount_no_decimals_with_space_separator}} Kč and the cart (dl-cart.js). */
const fmtPrice=v=>{const n=parseFloat(v);if(!isFinite(n))return"";return Math.round(n).toLocaleString("cs-CZ",{maximumFractionDigits:0})+" Kč";};

const css=document.createElement("style");
css.textContent=`
.dls-scrim{position:fixed;inset:0;background:rgba(20,18,12,.42);opacity:0;pointer-events:none;transition:opacity .2s ease;z-index:10001}
.dls-scrim.open{opacity:1;pointer-events:auto}
.dls{position:fixed;left:0;right:0;top:0;z-index:10002;background:#fff;transform:translateY(-101%);transition:transform .26s cubic-bezier(.4,0,.2,1);box-shadow:0 24px 48px rgba(20,18,12,.16)}
.dls.open{transform:none}
.dls .q{display:flex;align-items:center;gap:14px;padding:20px clamp(20px,3vw,46px) 16px;border-bottom:1px solid var(--line-2,#EEEDE9)}
.dls .q .ic{width:24px;height:24px;color:#98948C;flex:none}
.dls .q input{flex:1;min-width:0;border:none;outline:none;background:none;font:inherit;font-size:clamp(22px,2.6vw,30px);font-weight:700;letter-spacing:-.03em;color:#1A1916;caret-color:#C41B1F}
.dls .q input::placeholder{color:#98948C;font-weight:600}
/* 2026-10-05: the „esc" pill is the shared ✕ now (.dl-x, dl-x.css); the footer still says „esc zavřít".
   The negative margins keep the 44px box from growing the row and put the glyph's edge on the padding. */
.dls .q .esc{margin:-4px -11px -4px 0}

/* ---- pruh značky / kategorie ---- */
.dls .band{display:none}
.dls .band.on{display:flex;align-items:center;gap:clamp(16px,2vw,28px);padding:16px clamp(20px,3vw,46px);border-bottom:1px solid #EEEDE9;text-decoration:none;color:#1A1916;background:#fff;transition:background .14s ease}
.dls .band.on:hover,.dls .band.on.sel{background:#FBFAF8}
.dls .band .lg{flex:none;width:clamp(88px,9vw,132px);height:38px;display:flex;align-items:center}
.dls .band .lg img{max-width:100%;max-height:100%;object-fit:contain;object-position:left center}
.dls .band .lg .wm{font-size:17px;font-weight:800;letter-spacing:-.02em}
.dls .band .bt{display:flex;flex-direction:column;gap:3px;min-width:0}
.dls .band .bk{font-family:var(--mono);font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#98948C}
.dls .band .bn{font-size:clamp(17px,1.6vw,21px);font-weight:700;letter-spacing:-.02em}
.dls .band .bc{margin-left:auto;flex:none;display:flex;align-items:center;gap:12px;font-family:var(--mono);font-size:11px;color:#98948C;white-space:nowrap}
.dls .band .ar{font-family:inherit;font-size:16px;color:#C5161B}

.dls .grid{display:grid;grid-template-columns:250px 1fr}
.dls .grid.nosug{grid-template-columns:1fr}
.dls .grid.nosug .col.l{display:none}
.dls h6{font-family:var(--mono);font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#98948C;margin:0 0 10px}
.dls .col{padding:20px clamp(20px,3vw,46px) 24px}
.dls .col.r{padding-bottom:0}
.dls .col.l{border-right:1px solid #EEEDE9}
.dls .sug a{display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:8px 10px;margin:0 -10px;font-size:15.5px;font-weight:600;color:#1A1916;text-decoration:none}
.dls .sug a:hover,.dls .sug a.sel{background:#FBFAF8;color:#C5161B}
.dls .sug a .k{font-family:var(--mono);font-size:10px;color:#98948C;font-weight:500;white-space:nowrap}
/* bílé pole, karty drží vlasové linky — dřív to bylo šedé pozadí prosvítající mezerami */
.dls .res{display:grid;grid-template-columns:repeat(auto-fill,minmax(196px,1fr));gap:0;background:#fff;border-top:1px solid #EEEDE9;border-left:1px solid #EEEDE9}
.dls .res>*{border-right:1px solid #EEEDE9;border-bottom:1px solid #EEEDE9;min-width:0}
.dls .empty{font-size:15.5px;color:#57544E;padding:4px 0 10px}
.dls .foot{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px clamp(20px,3vw,46px);border-top:1px solid #EEEDE9;font-family:var(--mono);font-size:11px;color:#98948C;letter-spacing:.06em;text-transform:uppercase}
.dls .foot a.all{font-family:inherit;font-size:14.5px;font-weight:700;color:#1A1916;text-transform:none;letter-spacing:-.01em;text-decoration:none}
.dls .foot a.all span{color:#C5161B}
.dls mark{background:none;color:#C5161B}
@media (max-width:900px){
  .dls .grid{grid-template-columns:1fr}
  .dls .col.l{border-right:none;border-bottom:1px solid #EEEDE9}
  .dls .res{grid-template-columns:repeat(auto-fill,minmax(150px,1fr))}
  .dls .band .lg{width:80px;height:30px}
}
`;
document.head.appendChild(css);

const scrim=document.createElement("div"); scrim.className="dls-scrim";
const box=document.createElement("div"); box.className="dls";
box.innerHTML='<div class="q"><svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path></svg><input type="search" autocomplete="off" placeholder="Hledejte produkty, značky, kategorie nebo místnosti"><button type="button" class="esc dl-x" aria-label="Zavřít"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div><a class="band" href="#"></a><div class="grid"><div class="col l"><h6 class="st">Nejhledanější</h6><nav class="sug"></nav></div><div class="col r"><h6 class="rt">Oblíbené produkty</h6><div class="res"></div><div class="empty" hidden></div></div></div><div class="foot"><a class="all" href="'+SEARCH_URL+'">Kompletní katalog'+(CATALOG?" · "+CATALOG:"")+' <span>→</span></a><span>↑↓ procházet · enter otevřít · esc zavřít</span></div>';
document.body.append(scrim,box);

const input=$("input",box), sug=$(".sug",box), res=$(".res",box), empty=$(".empty",box);
const band=$(".band",box), grid=$(".grid",box);
const DEFAULTS=cfg.defaults||{queries:[],products:[]};
/* ---------- rychlé přidání do košíku přímo z výsledků (2026-09-02) ----------
   Predictive search NEVRACÍ variant id ani dostupnost — payload zná jen title, vendor, price,
   image a url (viz mapování na řádku `prods=` níž). Variantu proto dohledáváme až v okamžiku
   kliknutí z /products/<handle>.js, a to do TÉŽE sessionStorage cache, kterou plní dl-cart.js
   (klíč `dlk-p-<handle>`) — druhé kliknutí na stejný produkt už nestahuje nic.
   Přidáváme první dostupnou variantu a toast ji pojmenuje; opravit se dá v košíku, kde má
   dlaždice svůj výběr varianty. Vědomé rozhodnutí: rychlost teď, přesnost při kontrole. */
const handleFrom=u=>{const s=String(u||"").split("?")[0].replace(/\/+$/,"");const i=s.indexOf("/products/");return i<0?"":s.slice(i+10).split("/")[0];};
const SHOP_ROOT=SEARCH_URL.replace(/\/search\/?$/,"");
let ROOMS=[];
function loadRooms(){
  return fetch("/cart.js",{credentials:"same-origin"}).then(r=>r.json()).then(c=>{
    ROOMS=String((c.attributes||{})["Místnosti"]||"").split("|").filter(Boolean);return ROOMS;
  }).catch(()=>ROOMS);
}
/* #dlk-toast je globální prvek košíku, je na stránce i mimo /cart — sdílíme ho, ať se hlášky
   z vyhledávání chovají stejně jako hlášky z košíku. Když tam není, mlčíme. */
function toast(m){
  const t=document.getElementById("dlk-toast");if(!t)return;
  t.textContent=m;t.classList.add("on");clearTimeout(t._h);t._h=setTimeout(()=>t.classList.remove("on"),2600);
}
const PCACHE={};
function productFor(h){
  if(PCACHE[h])return Promise.resolve(PCACHE[h]);
  try{const c=sessionStorage.getItem("dlk-p-"+h);if(c){PCACHE[h]=JSON.parse(c);return Promise.resolve(PCACHE[h]);}}catch(e){}
  return fetch(SHOP_ROOT+"/products/"+h+".js").then(r=>r.ok?r.json():null).then(p=>{
    if(p){PCACHE[h]=p;try{sessionStorage.setItem("dlk-p-"+h,JSON.stringify(p));}catch(e){}}
    return p;
  }).catch(()=>null);
}
const QA_PLUS='<svg class="ic pl" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>';
const QA_TICK='<svg class="ic tk" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"></path></svg>';
const pcard=p=>{
  const h=handleFrom(p.url);
  return '<a class="pcard" href="'+p.url+'"><span class="th"><img src="'+p.image+'" alt="" loading="lazy"><span class="pr">'+p.price+'</span></span>'+
  /* `qa1` on .meta is what the flex rules key off. Scoping them to a class that only the NEW
     markup carries means the stylesheet and the script can land in either order during a deploy:
     old markup never matches, so it keeps its stacked display:block layout instead of throwing
     the title and vendor side by side for however long the two uploads are apart. */
  '<span class="meta qa1"><span class="mt"><span class="nm">'+esc(p.title)+'</span><span class="br">'+esc(p.vendor)+'</span></span>'+
  (h?'<span class="qa" role="button" tabindex="0" aria-label="Přidat do košíku" title="Přidat do košíku" data-qa="'+esc(h)+'">'+QA_PLUS+QA_TICK+'</span>':'')+
  '</span></a>';
};
let sel=0, timer=null, ctrl=null, usedArrows=false;

/* pruh značky: první nalezená kolekce. Logo a počet dorazí z konfigurace,
   když kolekci známe; jinak stačí název a šipka — nikdy neposláme nikam naprázdno. */
function showBand(col){
  if(!col){ band.classList.remove("on","sel"); return; }
  const b=BRANDS[handleOf(col.url)]||null;
  const known=!!b;
  band.href=(b&&b.url)||col.url;
  band.innerHTML=
    '<span class="lg">'+((b&&b.logo)?'<img src="'+b.logo+'" alt="'+esc(col.title)+'">':'<span class="wm">'+esc(col.title)+'</span>')+'</span>'+
    '<span class="bt"><span class="bk">'+(known?"Značka":"Kategorie")+'</span><span class="bn">'+esc((b&&b.title)||col.title)+'</span></span>'+
    '<span class="bc">'+((b&&b.count)?esc(b.count)+" produktů":"")+'<span class="ar">→</span></span>';
  band.classList.add("on");
}
function navItems(){ return (band.classList.contains("on")?[band]:[]).concat($$("a",sug)); }
function paintSel(){ navItems().forEach((a,i)=>a.classList.toggle("sel",i===sel)); }

function renderDefault(){
  showBand(null);
  grid.classList.remove("nosug");
  $(".st",box).textContent="Nejhledanější"; $(".rt",box).textContent="Oblíbené produkty";
  sug.innerHTML=DEFAULTS.queries.map((q,i)=>'<a href="'+q.url+'" class="'+(i?"":"sel")+'"><span>'+esc(q.label)+'</span><span class="k">'+esc(q.meta||"")+'</span></a>').join("");
  res.innerHTML=DEFAULTS.products.map(pcard).join(""); res.hidden=false; empty.hidden=true;
  $(".all",box).innerHTML='Kompletní katalog'+(CATALOG?" · "+CATALOG:"")+' <span>→</span>';
  $(".all",box).href=SEARCH_URL;
  sel=0;
}
async function run(q){
  ctrl&&ctrl.abort(); ctrl=new AbortController();
  const url=ROOT+"?q="+encodeURIComponent(q)+"&resources[type]=query,collection,product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last";
  let d; try{ d=await (await fetch(url,{signal:ctrl.signal})).json(); }catch(e){ return; }
  if(!d||!d.resources||!d.resources.results) return;
  const r=d.resources.results;
  $(".st",box).textContent="Návrhy"; $(".rt",box).textContent="Produkty";
  const cols=r.collections||[];
  showBand(cols[0]||null);
  /* první kolekce je v pruhu, do sloupce jdou zbylé kolekce a dotazy */
  const items=[
    ...cols.slice(1).map(c=>({label:c.title,url:c.url,meta:"kolekce"})),
    ...(r.queries||[]).map(x=>({label:x.text,url:SEARCH_URL+"?q="+encodeURIComponent(x.text)+"&type=product",meta:"dotaz"}))
  ].slice(0,7);
  /* bez návrhů nemá levý sloupec co ukázat — schová se a produkty zaberou celou šířku */
  grid.classList.toggle("nosug",items.length===0);
  sug.innerHTML=items.map((s,i)=>'<a href="'+s.url+'"><span>'+esc(s.label)+'</span><span class="k">'+esc(s.meta)+'</span></a>').join("");
  /* 2026-10-29: přesná shoda napřed, „podobné“ z API až za ní pod vlastním štítkem (DL_SEARCH.rank v dl-fuzzy.js) */
  const ranked=cfg.rank?cfg.rank(q,r.products||[]):(r.products||[]);
  const prods=ranked.slice(0,10).map(p=>({url:p.url,title:p.title,vendor:p.vendor,price:fmtPrice(p.price),image:p.featured_image&&p.featured_image.url,sim:!!p._similar}));
  if(prods.length){ res.hidden=false; empty.hidden=true;
    res.innerHTML=prods.map((p,i)=>(p.sim&&!(prods[i-1]||{}).sim?'<div class="sim">Podobné</div>':'')+pcard(p)).join("");
    $(".all",box).innerHTML='Všechny výsledky pro „'+esc(q)+'" <span>→</span>';
    $(".all",box).href=SEARCH_URL+"?q="+encodeURIComponent(q)+"&type=product";
  } else { res.hidden=true; empty.hidden=false;
    empty.innerHTML='Pro <b>„'+esc(q)+'"</b> jsme nenašli žádné produkty. Zkuste „závěsná", „artemide" nebo „E27".'; }
  sel=0; usedArrows=false; paintSel();
}
input.addEventListener("input",()=>{
  const q=input.value.trim(); clearTimeout(timer); usedArrows=false;
  if(!q){ renderDefault(); return; }
  timer=setTimeout(()=>run(q),180);
});
function open(seed){
  if(seed!==undefined&&seed!==null) input.value=seed;
  usedArrows=false;
  scrim.classList.add("open"); box.classList.add("open"); document.body.style.overflow="hidden";
  closeMenu(); loadRooms();   /* místnosti pro cíle „+“ — čerstvé při každém otevření */
  input.value.trim()?run(input.value.trim()):renderDefault();
  setTimeout(()=>input.focus(),40);
}
function close(){ scrim.classList.remove("open"); box.classList.remove("open"); document.body.style.overflow=""; input.blur(); }
scrim.addEventListener("click",close); $(".esc",box).addEventListener("click",close);
document.addEventListener("keydown",e=>{
  if(e.key==="/"&&!box.classList.contains("open")&&!/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)){e.preventDefault();open("");return;}
  if(!box.classList.contains("open")) return;
  if(e.key==="Escape"){ input.value?(input.value="",renderDefault()):close(); }
  if(e.key==="ArrowDown"||e.key==="ArrowUp"){
    e.preventDefault(); const it=navItems(); if(!it.length) return;
    usedArrows=true;
    sel=(sel+(e.key==="ArrowDown"?1:-1)+it.length)%it.length;
    paintSel();
  }
  if(e.key==="Enter"){
    const q=input.value.trim(); const a=navItems()[sel];
    if(usedArrows&&a&&a.getAttribute("href")){ location.href=a.href; }
    else if(q){ location.href=SEARCH_URL+"?q="+encodeURIComponent(q)+"&type=product"; }
    else if(a&&a.getAttribute("href")){ location.href=a.href; }
  }
});
$$("[data-search-open]").forEach(el=>el.addEventListener("click",e=>{e.preventDefault();open("")}));
$$("[data-search-input]").forEach(i=>{
  i.addEventListener("focus",()=>open(i.value));
  i.closest("form")&&i.closest("form").addEventListener("submit",e=>{e.preventDefault();open(i.value)});
});
/* ---------- quick-add: chování ----------
   Karta je <a>, takže každý zásah musí zastavit i default (navigaci) i bublání. Menu se staví
   AŽ PŘI OTEVŘENÍ, ne do markupu karty: res.innerHTML se přepisuje při každém stisku klávesy,
   takže cokoli předrenderovaného by se stejně zahodilo — a ROOMS se mezitím může změnit. */
function closeMenu(){
  const m=res.querySelector(".qam");if(m)m.parentNode.removeChild(m);
  $$(".qa.on",res).forEach(x=>x.classList.remove("on"));
}
function openMenu(qa){
  closeMenu();
  const h=qa.dataset.qa;
  const rows=['<span class="qai" tabindex="0" data-qaroom="'+esc(h)+'|">Nezařazeno</span>']
    .concat(ROOMS.map(r=>'<span class="qai" tabindex="0" data-qaroom="'+esc(h)+'|'+esc(r)+'">'+esc(r)+'</span>'));
  const m=document.createElement("span");
  m.className="qam";m.innerHTML='<span class="qah">Přidat do místnosti</span>'+rows.join("");
  qa.appendChild(m);qa.classList.add("on");
}
function addTo(handle,room,qa){
  if(qa&&qa.classList.contains("busy"))return;
  qa&&qa.classList.add("busy");
  productFor(handle).then(p=>{
    if(!p||!p.variants||!p.variants.length) throw new Error("Produkt se nepodařilo načíst");
    const v=p.variants.find(x=>x.available)||p.variants[0];
    const it={id:v.id,quantity:1,properties:{}};
    if(room) it.properties["Místnost"]=room;
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[it]})})
      .then(r=>r.ok?r.json():r.json().then(err=>{throw new Error((err&&err.description)||"Nepodařilo se přidat do košíku");}))
      .then(()=>{
        const vt=(v.title&&v.title!=="Default Title")?" · "+v.title:"";
        toast("Přidáno: "+p.title+vt+" → "+(room||"Nezařazeno"));
        if(qa){qa.classList.remove("busy");qa.classList.add("done");setTimeout(()=>qa.classList.remove("done"),1500);}
        /* košík se překreslí sám (drawer, počet v hlavičce a deska, když stojíme na /cart);
           panel zůstává otevřený, aby šlo přidat pět svítidel za sebou */
        if(window.DLK_CART&&window.DLK_CART.refresh) window.DLK_CART.refresh();
        return loadRooms();
      });
  }).catch(err=>{
    qa&&qa.classList.remove("busy");
    toast((err&&err.message)||"Nepodařilo se přidat do košíku");
  });
}
let hoverT=null;
res.addEventListener("mouseover",e=>{
  if(!e.target.closest)return;
  if(e.target.closest(".qam")){clearTimeout(hoverT);return;}
  const qa=e.target.closest(".qa[data-qa]");
  if(!qa||!ROOMS.length)return;
  clearTimeout(hoverT);
  if(!qa.classList.contains("on")) hoverT=setTimeout(()=>openMenu(qa),140);
});
res.addEventListener("mouseout",e=>{
  if(!res.querySelector(".qam"))return;
  const to=e.relatedTarget;
  if(to&&to.closest&&(to.closest(".qa")||to.closest(".qam")))return;
  clearTimeout(hoverT);hoverT=setTimeout(closeMenu,260);
});
res.addEventListener("click",e=>{
  if(!e.target.closest)return;
  const row=e.target.closest("[data-qaroom]");
  if(row){
    e.preventDefault();e.stopPropagation();
    const v=row.dataset.qaroom,i=v.indexOf("|"),qa=row.closest(".qa");
    closeMenu();addTo(v.slice(0,i),v.slice(i+1)||null,qa);return;
  }
  const qa=e.target.closest(".qa[data-qa]");
  if(!qa)return;
  e.preventDefault();e.stopPropagation();
  /* bez místností není z čeho vybírat — jedno kliknutí, rovnou do Nezařazeno */
  if(!ROOMS.length){addTo(qa.dataset.qa,null,qa);return;}
  qa.classList.contains("on")?closeMenu():openMenu(qa);
});
res.addEventListener("keydown",e=>{
  if(e.key!=="Enter"&&e.key!==" ")return;
  const t=e.target;if(!t.classList)return;
  if(t.classList.contains("qai")||t.classList.contains("qa")){e.preventDefault();e.stopPropagation();t.click();}
});
/* capture, aby Escape zavřel nejdřív menu a teprve podruhé celý panel — listener panelu
   sedí na document v bublací fázi, takže mu stopPropagation tady zabrání */
document.addEventListener("keydown",e=>{
  if(e.key==="Escape"&&res.querySelector(".qam")){e.stopPropagation();closeMenu();}
},true);
document.addEventListener("click",e=>{
  if(e.target.closest&&e.target.closest(".qa"))return;
  closeMenu();
});
window.DLSearch={open,close};
})();
